import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { REGEX } from '@app/utils/constants/regex.constants';

const MIN_LENGTH = 2;
const MAX_LENGTH = 30;

export function fullNameValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = typeof control.value === 'string' ? control.value : '';

    if (!value) {
      return null;
    }

    if (value.length < MIN_LENGTH || value.length > MAX_LENGTH) {
      return { invalidName: true };
    }

    if (!REGEX.name.test(value)) {
      return { invalidName: true };
    }

    return null;
  };
}
